<template>
  <div class="primaryOrder">
    <base-list-management
      ref="baseListManagement"
      :configData.sync="c_primaryOrderConfigData"
    />
  </div>
</template>
<script>
// api
import { searchByCustomerName } from '@/api/domain/customers'
import { closeEnterpriseOrder } from '@/api/purchaseAndSaleAPI'
// 配置
// eslint-disable-next-line import/no-cycle
import config from '../config'

export default {
  data() {
    const { c_primaryOrderConfigData } = config.call(this)
    return {
      c_primaryOrderConfigData,
    }
  },
  methods: {
    // 订单关闭
    // eslint-disable-next-line vue/no-unused-properties
    getVoidComplete(item) {
      // // 订单状态「待确认」「进行中」「已完成」
      this.$confirm('请确认是否关闭订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const { id } = item
          const res = await closeEnterpriseOrder({ id })
          if (res.code === 1) {
            this.$message({
              type: 'success',
              message: '关闭成功!',
            })
            this.$refs.baseListManagement.searchForm()
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    // 点击跳转新增车辆页面
    // eslint-disable-next-line vue/no-unused-properties
    handleAddCarClick(rowData) {
      this.$router.push({
        path: '/underLease/underLeaseOrder/entAddCar',
        query: {
          orderId: rowData.id,
          customerName: rowData.customerName,
          customerId: rowData.customerId,
          deptId: rowData.deptId,
        },
      })
    },
    // 详情页
    // eslint-disable-next-line vue/no-unused-properties
    handleOrderDetail(id) {
      this.$router.push({
        path: '/underLease/underLeaseOrder/primaryOrderDetail',
        query: { id },
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    dealWithSearch(val) {
      return {
        ...val,
        state: 2, // 履约中
        createStartTime: val.startTime ? val.startTime[0] : '',
        createEndTime: val.startTime ? val.startTime[1] : '',
      }
    },
    // 客户模糊查询
    // eslint-disable-next-line vue/no-unused-properties
    customerRemoteMethod(query) {
      if (query.length >= 1) {
        searchByCustomerName({
          customerState: 1,
          customerType: 2,
          customerName: query,
        }).then((res) => {
          const { data } = res
          this.$refs.baseListManagement.setItemData({
            elConfigKey: 'list',
            key: 'customerId',
            data,
          })
        })
      }
    },
  },
}
</script>
